import { SxProps } from '@mui/material';
import { grey10 } from 'app/components/ThemeProvider/colors';

export const inputBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '320px',

  '& .Mui-disabled': {
    background: grey10,
  },

  '& .MuiInputBase-readOnly': {
    background: '#F9FAFB',
  },

  '@media screen and (max-width: 1100px)': {
    width: '100%',
  },
};

export const inputOutlined = (multiline?: boolean) => {
  return {
    fontSize: '16px',
    fontWeight: 400,
    borderWidth: '1px',
    borderRadius: '8px',
    height: multiline ? 'auto' : '48px',
    lineHeight: multiline ? 1.5 : 1,
    marginTop: '8px',

    ...(multiline && {
      padding: '0 !important',
    }),
  };
};
